import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Input, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';

const UploadImageDialog = ({ open, onClose, onUpload }) => {
    const [selectedImage, setSelectedImage] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) setSelectedImage(file);
    };

    const handleUpload = () => {
        if (selectedImage) {
            onUpload(selectedImage);
            setSelectedImage(null);
            onClose();
        }
    };

    const handleClose = () => {
        onClose();
        setTimeout(() => setSelectedImage(null), 150);
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}><PhotoCameraIcon sx={{ color: 'primary.main' }} />Upload Image</DialogTitle>
            <DialogContent>
                <Input
                    accept="image/*"
                    id="file-input"
                    type="file"
                    onChange={handleFileChange}
                    sx={{ display: 'none' }}
                />

                {!selectedImage ? (
                    <label htmlFor="file-input">
                        <Box
                            component="span"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 1.5,
                                py: 4,
                                border: '2px dashed',
                                borderColor: 'divider',
                                borderRadius: 2,
                                cursor: 'pointer',
                                '&:hover': { borderColor: 'primary.main', bgcolor: 'action.hover' },
                            }}
                        >
                            <CloudUploadIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
                            <Typography variant="body2" color="text.secondary">
                                Click to choose an image
                            </Typography>
                        </Box>
                    </label>
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, pt: 1 }}>
                        <Box
                            component="img"
                            src={URL.createObjectURL(selectedImage)}
                            alt="Preview"
                            sx={{ maxWidth: '100%', maxHeight: 240, borderRadius: 2, objectFit: 'contain' }}
                        />
                        <label htmlFor="file-input">
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                            >
                                Choose a different image
                            </Typography>
                        </label>
                    </Box>
                )}
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                <Button onClick={handleClose}>Cancel</Button>
                {selectedImage && (
                    <Button variant="contained" onClick={handleUpload}>Upload</Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default UploadImageDialog;
